import { UserModel } from '../../models';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectCommentingFeature } from '../../store/selectors';

@Injectable()
export class UserFacadeService {
  constructor(private store: Store<any>) {}
  getUsersDictionaryByFullName(): Observable<{ [fullName: string]: UserModel }> {
    return this.store.select(selectCommentingFeature).pipe(map((state) => state.userState.dictionaryByFullName));
  }
}
